import type { PassioCallRecord } from "@passio/api-client";
import type { ChainCallRecord } from "@passio/easyai-client";
import { createStore, useStore } from "./store";

const MAX = 30;

/** A Passio API call, or one EasyAI chain run (execute plus polling). */
export type CallRecord = PassioCallRecord | ChainCallRecord;

export const isChainCall = (r: CallRecord): r is ChainCallRecord => "kind" in r && r.kind === "chain";

export const callHistory = createStore<CallRecord[]>([]);

/** New calls go on top; a call already listed (a chain run reporting progress) is updated where it is. */
export function pushCall(r: CallRecord) {
  callHistory.set((list) => (list.some((x) => x.id === r.id) ? list.map((x) => (x.id === r.id ? r : x)) : [r, ...list].slice(0, MAX)));
}

export const useCallHistory = () => useStore(callHistory);
export const clearCalls = () => callHistory.set([]);

/** Inspector open state + which call is selected (null = latest). */
export const inspectorState = createStore<{ open: boolean; selectedId: string | null }>({ open: false, selectedId: null });
export const useInspector = () => useStore(inspectorState);
export const openInspector = (selectedId: string | null = null) => inspectorState.set({ open: true, selectedId });
export const closeInspector = () => inspectorState.set((s) => ({ ...s, open: false }));
